import { S3File } from "@dune/types";
import { Button, Card, ControlledColorPicker } from "@dune/ui";
import { Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { ControlledS3FileInput } from "../../../../../../component/form/controlledS3Input";

export const GraphicCharter: React.FC = () => {
	const { control, setValue } = useFormContext();
	const logoFile = useWatch({ control, name: "graphicCharter.logo" });

	const [previewFile, setPreviewFile] = useState<S3File | undefined>(undefined);

	useEffect(() => {
		if (logoFile?.url) {
			setPreviewFile(logoFile);
		} else {
			setPreviewFile(undefined);
		}
	}, [logoFile]);

	const handleDeleteLogo = () => {
		setValue("graphicCharter.logo", undefined);
		setPreviewFile(undefined);
	};

	return (
		<div className="py-4">
			<div className="flex flex-col gap-4 pb-3 w-full">
				<div className="text-text-main-blue  font-semibold">
					Charte graphique
				</div>
				<Card className="p-6 flex flex-col gap-4 overflow-auto text-text-secondary-blue">
					<div className="flex flex-row gap-4">
						<div className="flex flex-col items-start gap-3 w-full">
							<div className="text-text-secondary-blue">Logo</div>
							<div className="flex flex-row items-center gap-4">
								{previewFile?.url ? (
									<div className="relative">
										<img
											src={previewFile.url}
											alt={previewFile.name ?? ""}
											className="w-16 h-16 rounded-full object-cover border border-gray-200 bg-white"
											style={{ objectFit: "cover" }}
										/>
										<Button
											variant="destructive"
											size="icon"
											className="absolute -top-2 -right-2 h-6 w-6"
											onClick={handleDeleteLogo}
										>
											<Trash2 className="h-4 w-4" />
										</Button>
									</div>
								) : (
									<div className="w-16 h-16 rounded-full border border-gray-200 bg-white" />
								)}
								<div className="flex-1 w-full">
									<ControlledS3FileInput
										name="graphicCharter.logo"
										control={control}
										bucket="private"
										onPreview={setPreviewFile}
										subText="SVG, PNG, JPG (max. 800x400px)"
										hidePreviewButton={true}
									/>
								</div>
							</div>
						</div>
						<div className="flex flex-col items-stretch gap-3 w-full">
							<ControlledColorPicker
								label="Couleur"
								control={control}
								name="graphicCharter.color"
							/>
						</div>
					</div>
				</Card>
			</div>
		</div>
	);
};
